import { render, staticRenderFns } from "./AccountantWidget.vue?vue&type=template&id=f49541e4&"
import script from "./AccountantWidget.vue?vue&type=script&lang=js&"
export * from "./AccountantWidget.vue?vue&type=script&lang=js&"
import style0 from "./AccountantWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports